import { useSelector } from 'react-redux'
import ChatFrame from '@components/chat/ChatFrame'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'

/**
 * Mobile / tablet chat: a full-screen overlay mounted once (so it preloads in
 * the background) and revealed when the player opens it from the header button.
 * Desktop docks chat inside the activity panel instead, so this renders nothing
 * there.
 */
const ChatOverlay = () => {
  const { chat } = useSelector((state) => state.configurations.featureToggles)
  const isDesktop = useSelector((state) => state.layout.mode) === INTERNAL_CONSTANTS.DEVICES.DESKTOP
  const open = useSelector((state) => state.ui.chat.open)

  if (!chat || isDesktop) return null

  return <ChatFrame visible={open} />
}

export default ChatOverlay
